import { ButtonLink, Icon, StandAloneLink, Surface, Txt } from '@vst/beam';
import { ArrowBack } from '@vst/beam-icons/icons';
import { SpacingTypes } from '@vst/beam/src/react/common';

import { useScreenResolution } from '@app/hooks';

import styles from './styles.module.scss';

type HeaderWithBackNavigationProps = {
  title: string;
  additionalClassName?: string;
  handleBackNavigation: (e: React.MouseEvent<HTMLElement>) => void;
  goBackLabel: string;
  style?: React.CSSProperties;
  my?: SpacingTypes;
  additionalButton?: React.ReactNode;
  subHeader?: string;
};

export const HeaderWithBackNavigation = ({
  title,
  additionalClassName,
  handleBackNavigation,
  goBackLabel,
  style,
  my,
  additionalButton,
  subHeader,
}: HeaderWithBackNavigationProps) => {
  const { isExtraSmall, isSmall } = useScreenResolution();
  const isMobile = isSmall || isExtraSmall;

  const defaultSurfaceClassName = styles['headerWithBackNavWrapper'];
  const surfaceClassName = additionalClassName
    ? `${defaultSurfaceClassName} ${additionalClassName}`
    : defaultSurfaceClassName;

  return (
    <Surface variant={isMobile ? 'primary' : 'secondary'} className={surfaceClassName} style={style} my={my}>
      <div data-cy="navigation-header-layout" className={styles['layout']}>
        <BackButton handleClick={handleBackNavigation} goBackLabel={goBackLabel} />
        <div>
          <Txt data-cy="page-title" variant={isMobile ? 'heading5' : 'heading3'}>
            {title}
          </Txt>
          <Txt data-cy="sub-header" variant={isMobile ? 'bodySmallRegular' : 'subHeading3'} color="subtle">
            {subHeader}
          </Txt>
        </div>
        {additionalButton}
      </div>
    </Surface>
  );
};

interface BackButtonProps {
  handleClick: (e: React.MouseEvent<HTMLElement>) => void;
  goBackLabel: string;
}

const BackButton = ({ handleClick, goBackLabel }: BackButtonProps) => {
  const { isExtraSmall, isSmall } = useScreenResolution();
  const isMobile = isSmall || isExtraSmall;

  const onClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    handleClick(e);
  };

  if (isMobile) {
    return (
      <StandAloneLink href="#" onClick={onClick} data-cy="go-back-link">
        <Icon icon={ArrowBack} color="gray_600" />
      </StandAloneLink>
    );
  }

  return (
    <ButtonLink
      data-cy="go-back-button-link"
      linkSize="medium"
      onClick={onClick}
      arrowPos={isMobile ? undefined : 'back'}
      href="#"
      variant={isMobile ? 'secondary' : 'primary'}
      label={isMobile ? '' : goBackLabel}
    />
  );
};
